import { Link } from "react-router-dom";
import { useState } from "react";
import { Mail, Crown } from "lucide-react";
import { api } from "../lib/api";
import { toast } from "sonner";
import RoyalDivider from "./RoyalDivider";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      await api.post("/newsletter/subscribe", { email });
      toast.success("Welcome to the adventure ✨");
      setEmail("");
    } catch {
      toast.error("Could not subscribe. Try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <footer className="mt-32 border-t-2 border-royal/20 bg-parchment/70" data-testid="footer">
      <div className="container-narrow pt-12 pb-4">
        <RoyalDivider label="the workshop" />
      </div>
      <div className="container-narrow pt-6 pb-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="inline-flex items-center gap-2 mb-3 text-gold">
            <Crown className="w-4 h-4" />
            <span className="royal-eyebrow">Letters home</span>
          </div>
          <h3 className="font-heading text-2xl md:text-3xl font-semibold mb-3 text-royal">Stories from the workshop.</h3>
          <p className="text-ink2 mb-5 max-w-md">
            One short letter every other Sunday — an idea, a SwiftUI snippet, and a peek at the next pop-up book.
          </p>
          <form onSubmit={subscribe} className="flex gap-2 max-w-md" data-testid="footer-newsletter-form">
            <input
              type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com" className="input-soft" data-testid="footer-newsletter-email"
            />
            <button className="btn-royal whitespace-nowrap" disabled={busy} data-testid="footer-newsletter-submit">
              {busy ? "..." : "Subscribe"}
            </button>
          </form>
        </div>
        <div>
          <div className="royal-eyebrow mb-4">Explore</div>
          <ul className="space-y-2 text-ink2">
            <li><Link to="/studio" className="hover:text-royal transition-colors">Prompt Studio</Link></li>
            <li><Link to="/lessons" className="hover:text-royal transition-colors">Lessons</Link></li>
            <li><Link to="/library" className="hover:text-royal transition-colors">The Curriculum</Link></li>
            <li><Link to="/books" className="hover:text-royal transition-colors">Pop-Up Books</Link></li>
            <li><Link to="/pricing" className="hover:text-royal transition-colors">Pricing</Link></li>
          </ul>
        </div>
        <div>
          <div className="royal-eyebrow mb-4">Adventure</div>
          <ul className="space-y-2 text-ink2">
            <li><Link to="/lessons" className="hover:text-royal transition-colors">Beginner path</Link></li>
            <li><Link to="/lessons" className="hover:text-royal transition-colors">Builder path</Link></li>
            <li><Link to="/lessons" className="hover:text-royal transition-colors">Professional path</Link></li>
          </ul>
          <div className="royal-eyebrow mb-3 mt-6">Get in touch</div>
          <a
            href="mailto:hello@durgaprogrammingadventures.com"
            className="inline-flex items-center gap-2 text-ink2 hover:text-marigold transition group"
            data-testid="footer-contact-email"
          >
            <Mail className="w-4 h-4 group-hover:scale-110 transition" />
            <span className="break-all">hello@durgaprogrammingadventures.com</span>
          </a>
        </div>
      </div>
      <div className="border-t border-royal/20 bg-cream/60">
        <div className="container-narrow py-6 flex flex-col md:flex-row justify-between gap-2 text-sm text-ink2">
          <div data-testid="footer-copyright">© {new Date().getFullYear()} Durga Programming Adventures · by Sarv Singh</div>
          <div className="font-heading italic text-royal">From prompt to App Store.</div>
        </div>
      </div>
    </footer>
  );
}
